// Shared booking / analytics helpers (mirrors LandingPage constants)
export const SITE_URL = "https://brandyourexpertise.com";
export const LINKEDIN_URL = "https://www.linkedin.com/in/fabienmoutier/";
export const EMAIL = "fabien@brandyourexpertise.com";
export const ICLOSED_BASE =
    "https://app.iclosed.io/e/FabienMoutier/pr-sentation";

// Track a Plausible custom event (no-op if Plausible isn't loaded yet)
export const trackEvent = (name, props) => {
    if (
        typeof window !== "undefined" &&
        typeof window.plausible === "function"
    ) {
        window.plausible(name, props ? { props } : undefined);
    }
};

// Build iClosed booking URL with UTM params to trace which CTA converted
export const bookingUrl = (source) => {
    const utm = new URLSearchParams({
        utm_source: "brandyourexpertise",
        utm_medium: "landing",
        utm_campaign: "seo-pages",
        utm_content: source,
    }).toString();
    return `${ICLOSED_BASE}?${utm}`;
};

export const onBookingClick = (source) => () =>
    trackEvent("Book Call", { source });
